import { render, staticRenderFns } from "./NewYearsGoodsFestivalTemp.vue?vue&type=template&id=2f7aaf39&scoped=true"
import script from "./NewYearsGoodsFestivalTemp.vue?vue&type=script&lang=js"
export * from "./NewYearsGoodsFestivalTemp.vue?vue&type=script&lang=js"
import style0 from "./NewYearsGoodsFestivalTemp.vue?vue&type=style&index=0&id=2f7aaf39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7aaf39",
  null
  
)

export default component.exports